// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kvB5","left":"styles_left__zOeyc","desktopActions":"styles_desktopActions__2FG_6","title":"styles_title__2q3gF"};